import React, { useEffect, useRef, useState } from "react";
import { isEmpty } from "lodash";

import MyAccountLayout from "./MyAccountLayout";
import MyAccountFilter from "./MyAccountFilter";
import Pagination from "../../components/Pagination";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { formatDate } from "../../Utils/Constant";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useParams } from "react-router-dom";

const style = { padding: "8px" };
const styleBody = { padding: "8px 7px" };

const ActivityLogs = () => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const tableRef = useRef();
  const params = useParams();
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    userType: params?.type,
    user_id: params?.id,
  });
  const [data, setData] = useState({});
  const [openRows, setOpenRows] = useState({});

  const getData = async (activeFilter) => {
    const { status, data: response_users } = await apiGet(
      apiPath.activityLog,
      activeFilter,
    );
    if (status === 200 && response_users.success) {
      setData(response_users.results);
    }
  };

  useEffect(() => {
    getData(filter);
  }, [filter.page, filter?.limit]);

  const handlePageChange = (newPage) =>
    setFilter((prev) => ({ ...prev, page: newPage }));

  const toggleRow = (id) =>
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));

  const rows = data?.data || [];

  return (
    <MyAccountLayout>
      <div className="col-center report">
        <div className="box" style={{ alignItems: "center" }}>
          <h2>Activity Log</h2>
          <MyAccountFilter
            tableRef={tableRef}
            fileName="activity-log"
            limit={filter?.limit}
            onChange={(e) => {
              setFilter((prev) => {
                return { ...prev, limit: Number(e.target.value), page: 1 };
              });
            }}
          />
        </div>

        <div className="table-responsive data-table">
          <table ref={tableRef} id="table01" className="table01">
            <tbody>
              <tr>
                <th style={style} width="15%" className="align-L sort_asc">
                  Login Date &amp; Time
                </th>
                <th style={style} width="15%" className="align-L sort_asc">
                  Login Status
                </th>
                <th style={style} width="12%" className="sort_asc">
                  IP Address
                </th>
                <th style={style} width="15%" className="sort_asc">
                  ISP
                </th>
                <th style={style} width className="sort_asc">
                  City/State/Country
                </th>
                <th style={style} width>
                  Action
                </th>
              </tr>
            </tbody>
            <tbody id="content">
              {!isEmpty(rows) ? (
                rows.map((item, key) => {
                  const rowId = item?._id || key;
                  const isOpen = !!openRows[rowId];
                  const isSuccess = /success/i.test(item?.activityStatus || "");
                  const ip =
                    (item?.ip && item.ip.replace("::ffff:", "")) || "N/A";

                  return (
                    <React.Fragment key={rowId}>
                      <tr id="tempTr">
                        <td
                          style={styleBody}
                          id="loginDate"
                          className="align-L"
                        >
                          {formatDate(item?.activityDate, user?.timeZone)}
                        </td>

                        <td
                          style={styleBody}
                          id="loginMessage"
                          className={`align-L ${isSuccess ? "success" : "danger"}`}
                        >
                          {item?.activityStatus}
                        </td>

                        <td style={styleBody} id="ipAddress">
                          {ip}
                        </td>
                        <td style={styleBody} id="isp">
                          {item?.isp || "-"}
                        </td>
                        <td style={styleBody} id="location">
                          {`${item?.city || ""}/${item?.region || ""}/${item?.country || ""}`}
                        </td>
                        <td style={styleBody} id="action">
                          <button
                            className="btn"
                            onClick={() => toggleRow(rowId)}
                          >
                            {isOpen ? "Hide" : "View"}
                          </button>
                        </td>
                      </tr>

                      {isOpen && (
                        <tr className="expand">
                          <td style={styleBody} colSpan={6}>
                            <strong>User Agent: </strong>
                            {item?.userAgent || "N/A"}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td style={styleBody} colSpan={6}>
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {rows.length > 0 && data?.totalDocs > 0 && (
            <Pagination pagination={data} onPageChange={handlePageChange} />
          )}
        </div>
      </div>
    </MyAccountLayout>
  );
};

export default ActivityLogs;
